import { createReducer, on } from '@ngrx/store';
import * as GridActions from '../actions/grid.actions';
import { DataTransform } from '../../../services/DataTransform';
import {MultiviewView} from '../../../services/api/multiviews/multiview.view.model';
import {Multiview} from '../../../services/api/multiviews/multiview-viewer.model';

export const gridFeatureKey = 'grid';

export interface State {
  record: Multiview | MultiviewView | null;
  updatedRecord: any;
  updatedVisibility: any;
  error: any;
  loaded: boolean;
  loading: boolean;
}

export const initialState: State = {
  record: null,
  updatedRecord: null,
  updatedVisibility: null,
  error: null,
  loaded: false,
  loading: false,
};


export const reducer = createReducer(
  initialState,

  on(GridActions.loadGrid, (state: State): State => ({
    ...state,
    error: null,
    loaded: false,
    loading: true,
  })),
  on(GridActions.loadGridSuccess, (state: State, action: {data: MultiviewView}): State => {
    let updatedDataGrids: Multiview | MultiviewView = action.data;
    if (action.data.entities) {
      updatedDataGrids = DataTransform.transfromGrids(action.data);
    }
    return ({
      ...state,
      record: updatedDataGrids,
      error: null,
      loaded: true,
      loading: false,
    });
  }),
  on(GridActions.loadUpdatedGridSuccess, (state: State, action): State => {
    const updatedDataGrids = DataTransform.transfromGrids(action.data);
    return ({
      ...state,
      updatedRecord: updatedDataGrids,
    });
  }),
  on(GridActions.loadGridFailure, (state: State, action: {error: unknown}): State => ({
    ...state,
    error: action.error,
    loaded: false,
    loading: false,
  })),
  on(GridActions.updateVisibility, (state: State, _action): State => ({
    ...state,
    updatedVisibility: true,
  })),
  on(GridActions.clearGridState, (state: State): State => ({
    ...state,
    record: null,
    error: null,
    loaded: false,
    loading: false,
  })),
);

